import { Component, h, Prop, Host, Watch, State } from '@stencil/core';
import { ProductPriceItem } from '../../../globals/shared/productprice/product-price-types';
import { state } from './pn-find-service-and-price-store';

@Component({
  tag: 'pn-find-service-and-price-result',
  styleUrl: 'pn-find-service-and-price-result.scss',
})
export class PnfindServiceAndPriceResult {
  @Prop({ mutable: true }) item: ProductPriceItem = null;

  @Prop() shownitems: ProductPriceItem[] = [];
  @State() weightText = '';
  componentWillLoad() {
    this.composeItems();
  }

  @Watch('item')
  composeItems() {
    this.shownitems = [this.item];
    // this.shownitems = [];
    // if (this.item.pricestamps) {
    //   this.shownitems.push({...this.item, priceagent: null, pricesenddirect: null});
    // }
    // if (this.item.priceagent) {
    //   this.shownitems.push({...this.item, pricestamps: null, pricesenddirect: null});
    // }
    // if (this.item.pricesenddirect) {
    //   this.shownitems.push({...this.item, pricestamps: null, priceagent: null});
    // }
    // Parcels are always in KG. Letter KG must be converted from grams
    // this.weightText = (this.item.what === "parcel") ? this.item.maxweight + 'kg' :
    // (this.item.what === "letter" && this.item.maxweight > 999) ? Math.round(this.item.maxweight/1000) + " kg" : this.item.maxweight + " g";
  }

  render() {
    return (
      <Host>
        {this.shownitems.map(item => (
          <pn-product-card>
            <pn-illustration slot="illustration" illustration={item.illustration}></pn-illustration>
            <div slot="content">
              <div class="content">
                <h3>{item.name}</h3>
                {item.description ? <div class="description">{item.description}</div> : null}
                {item.info ? <div class="description">{item.info}</div> : null}
              </div>
            </div>

            {item.maxweight ? <pn-product-tile-info label={state.i18n.maxweightlabel} text={this.weightText}></pn-product-tile-info> : null}
            {/* { item.maximummeasurements ? (<pn-product-tile-info label={state.i18n.maxmeasurementlabel} text={item.maximummeasurements}></pn-product-tile-info>) : null } */}
            {item.pricestamps ? (
              <pn-product-tile-price slot="price" label={state.i18n.stampshopcta} amount={item.pricestamps + ''} currency={state.market.currency}></pn-product-tile-price>
            ) : null}
            {/* { item.priceagent ? (<pn-product-tile-price slot="price" label="" amount={item.priceagent+''} currency={ state.market.currency } url="https://shop.postnord.se/ebutik/default.aspx"></pn-product-tile-price>) : null } */}
            {item.pricesenddirect ? (
              <pn-product-tile-price
                slot="price"
                label={state.i18n.senddirectcta}
                amount={item.pricesenddirect + ''}
                currency={state.market.currency}
                url="https://portal.postnord.com/skickadirekt/"
              ></pn-product-tile-price>
            ) : null}
            {item.note ? (
              <small slot="note">
                <p>{item.note}</p>
              </small>
            ) : null}
          </pn-product-card>
        ))}
      </Host>
    );
  }
}
